import React from 'react'

import { useTheme } from 'styled-components/native'

import { InfoIcon } from '../../atoms/icons/InfoIcon'
import { InlineBanner, InlineBannerProps } from '../inlineBanner/InlineBanner'

export interface InlineInfoBannerProps extends Omit<InlineBannerProps, 'backgroundColor'> {
  text: React.ReactNode | string
  testId?: string
  backgroundColor?: string
  iconColor?: string
  textColor?: string
  marginBottom?: string
  marginTop?: string
  iconSize?: number
}

export const InlineInfoBanner: React.FC<InlineInfoBannerProps> = ({
  text,
  testId,
  backgroundColor,
  iconColor,
  textColor,
  marginBottom,
  marginTop,
  trailingLink,
  iconSize,
  title,
}) => {
  const { colors } = useTheme()
  const { inlineInfoBanner } = colors.components

  const icon = <InfoIcon size={iconSize ?? 15} fillColor={iconColor || inlineInfoBanner.infoIcon.fill} />
  return (
    <InlineBanner
      text={text}
      title={title}
      icon={icon}
      testId={testId}
      backgroundColor={backgroundColor || inlineInfoBanner.background}
      textColor={textColor || inlineInfoBanner.text}
      marginBottom={marginBottom}
      marginTop={marginTop}
      trailingLink={trailingLink}
    />
  )
}
